import { AxiosError } from 'axios';
import { Auth, ErroResponse, Params, Usuario } from './auth.service.types';
import { UsuarioAura, consultaPerfilUsuarioPorTokenService } from './consultar-perfil-usuario-por-token.service';

const authService = async <T>({ token, url }: Params): Promise<Auth<T>> => {
  return consultaPerfilUsuarioPorTokenService<T>({ token, url })
    .then(({ dados, perfil }) => {
      const auth: Auth<T> = {
        user: { aura: { dados: dados, perfil } },
        pending: false,
        authorized: true,
        authenticated: true,
        loginProblem: null,
      };

      return auth;
    })
    .catch((error: AxiosError<ErroResponse>) => {
      const [{ motivo }] = error.response?.data?.erros ?? [{ motivo: 'ERRO_SERVICO_INDISPONIVEL' }];
      return {
        pending: false,
        authorized: false,
        authenticated: true,
        loginProblem: motivo || null,
        user: null,
      };
    });
};

export { authService };
export type { Auth, Usuario, UsuarioAura };
